import React from 'react';
import { Box, GridItem } from '@chakra-ui/react';

const Puls = () => {
  return (
    <Box>
      <Box as="h1" fontSize="34px" textTransform="uppercase" mb={5}>
        PULS
      </Box>
      <GridItem as="p">app mobile qui connecte les sportifs via la géolocalisation pour trouver DES Partenaires</GridItem>
      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [Objectifs]
      </Box>
      <GridItem as="p">Identifier les besoins utilisateurs</GridItem>
      <GridItem as="p" mb={5}>
        (questionnaires, personas, parcours)
      </GridItem>
      <GridItem as="p" mb={5}>
        Concevoir un prototype fluide, centré sur l’accessibilité et la rencontre sportive.
      </GridItem>
      <GridItem as="p">Imaginer des fonctionnalités clés : profils, dispo en temps réel, matching par affinités.</GridItem>
      <Box as="h1" fontSize="13px" textTransform="uppercase" mb={5} mt={5}>
        [LIENS]
      </Box>
      <Box>
        <a href="https://www.figma.com/deck/4t6vkGWiP9FTXaGSZHJ9e0/PULS?node-id=1-89&t=QCcimpdNPsQkn2I9-1" target="_blank" rel="noreferrer" style={{ textDecoration: 'underline' }}>
          Prototype FIGMA PULS
        </a>
      </Box>
      <Box>
        <a
          href="https://www.figma.com/proto/4w5QBu7oXQLLqAf9T4t3j4/Appli-Rencontre-Sportive?content-scaling=fixed&kind=proto&node-id=828-44173&page-id=19%3A122&scaling=min-zoom&t=R3kVg0WT2qjyw9UA-1"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: 'underline' }}
        >
          PDF Etudes PULS
        </a>
      </Box>
    </Box>
  );
};

export default Puls;
